import { StockStatuses } from '@dcxwam/dcx-wam-ui-foundations'
import type { GroupedItem, Item } from '../models'
import { getStockLevelStatus, Stocks, stockStatusMap } from './stock'

export const SORT_PARAM_KEY = 'sort'

export const sortVariantsBySequenceNumber = (
  a: Partial<Item>,
  b: Partial<Item>
) => {
  const aSequenceNumber = a?.sequenceNumber ?? Infinity
  const bSequenceNumber = b?.sequenceNumber ?? Infinity
  return aSequenceNumber - bSequenceNumber
}

export const sortItemsBySequenceNumber = (a: GroupedItem, b: GroupedItem) => {
  const aMinSequenceNumber = Math.min(
    ...a.variants.map(({ sequenceNumber = Infinity }) => sequenceNumber)
  )
  const bMinSequenceNumber = Math.min(
    ...b.variants.map(({ sequenceNumber = Infinity }) => sequenceNumber)
  )
  return aMinSequenceNumber - bMinSequenceNumber
}

enum OrderEnum {
  PriceAsc = 'price-asc',
  PriceDesc = 'price-desc'
}

export const sortItemsByPrice =
  (order: `${OrderEnum}` | string) => (a: GroupedItem, b: GroupedItem) => {
    const aMinPrice = Math.min(
      ...a.variants.map((item) =>
        Number(item?.price?.priceDiscount?.value ?? item?.price?.value ?? 0)
      )
    )
    const bMinPrice = Math.min(
      ...b.variants.map((item) =>
        Number(item?.price?.priceDiscount?.value ?? item?.price?.value ?? 0)
      )
    )
    switch (order) {
      case OrderEnum.PriceAsc:
        return aMinPrice - bMinPrice
      case OrderEnum.PriceDesc:
        return bMinPrice - aMinPrice
      default:
        return 0
    }
  }

export const sortVariantsByStock = (stocks?: Stocks) => (a: Item, b: Item) => {
  const asls = getStockLevelStatus(a, stocks)
  const bsls = getStockLevelStatus(b, stocks)

  if (stockStatusMap[asls] === StockStatuses.OutOfStock) {
    return 1
  }

  if (stockStatusMap[bsls] === StockStatuses.OutOfStock) {
    return -1
  }

  return 0
}
